import type { CmmdOrgProviderPolicy } from "@cmmd-forge/contracts";
import { useQuery } from "@tanstack/react-query";

import { createCmmdApiClient } from "../environments/cmmdApi";
import { resolveOrgProviderPolicy } from "../providerPickerAvailability";

const CMMD_ORG_PROVIDER_POLICY_QUERY_KEY = ["cmmd", "org-provider-policy"] as const;

export function useCmmdOrgProviderPolicy(enabled: boolean) {
  return useQuery({
    queryKey: CMMD_ORG_PROVIDER_POLICY_QUERY_KEY,
    queryFn: () => createCmmdApiClient().getOrgProviderPolicy(),
    enabled,
    staleTime: 30_000,
  });
}

export function orgProviderPolicyOrDefault(
  policy: CmmdOrgProviderPolicy | null | undefined,
): CmmdOrgProviderPolicy {
  return resolveOrgProviderPolicy(policy);
}
